angular.module('FlexyBeautyApp.services').
factory('ItemCategoryView',["$dialog", "CompanyImageFormat", "gettextCatalog",
    function ($dialog, CompanyImageFormat, gettextCatalog) {
    const ItemCategoryView = function () {
    };

    ItemCategoryView.prototype.isAllItemsImageInSquareFormat = function(items){
            return this.isAllItemsImageInFormat(items, CompanyImageFormat.SQUARE.label);
    };

    ItemCategoryView.prototype.isAllItemsImageInPortraitFormat = function(items){
        return this.isAllItemsImageInFormat(items, CompanyImageFormat.PORTRAIT.label);
    };

    ItemCategoryView.prototype.isAllItemsImageInRectFormat = function(items){
        return this.isAllItemsImageInFormat(items, CompanyImageFormat.RECT.label);
    };

    ItemCategoryView.prototype.isAllItemsImageInFormat = function(items, format){
        let isAllInFormat = true;
        for(let i = 0; i < items.length;i++){
            if(items[i].imageDisplayed && items[i].imageDisplayed.dim && items[i].imageDisplayed.dim !== format){
                isAllInFormat = false;
                break;
            }
        }
        return isAllInFormat;
    };

    ItemCategoryView.prototype.checkForRootSaveError = function(data) {
        if (data.data.message.includes("A root category already exists")) {
            let errorMessage = gettextCatalog.getString("Echec lors de la sauvegarde de catégorie, veuillez recharger l'application");
            let opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl: '/partials/global/errorDialog.html',
                controller: 'DialogCtrl',
                resolve: {
                    dialogsModel: function () {
                        let tableModel = [];
                        tableModel["label"] = errorMessage;
                        return tableModel;
                    }
                }
            };
            $dialog.dialog(opts).open();
        }
    };

    return ItemCategoryView;
}]);


// WEBPACK FOOTER //
// ./js/services/views/ItemCategoryView.js